import { AD_GALLERY_CREATE_FORMATS } from '../constants/adGalleryAnalytics';

/** Canonical `ad_format` values for Amplitude (kebab-case, aligned with ad gallery analytics). */
export const ANALYTICS_AD_FORMATS = {
  STANDARD_VIDEO: AD_GALLERY_CREATE_FORMATS.STANDARD_VIDEO,
  AD_SELECTOR: AD_GALLERY_CREATE_FORMATS.AD_SELECTOR,
  KERV_ENHANCED: 'kerv-enhanced',
  GATEWAY_GO: 'gateway-go',
} as const;

const normalizeAdFormatKey = (adFormat: string): string =>
  adFormat
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_');

export const normalizeAnalyticsAdFormat = (adFormat?: string | null): string | undefined => {
  if (!adFormat?.trim()) {
    return undefined;
  }

  switch (normalizeAdFormatKey(adFormat)) {
    case 'STANDARD':
    case 'STANDARD_VIDEO':
    case 'VIDEO':
    case 'STANDARD_VAST':
      return ANALYTICS_AD_FORMATS.STANDARD_VIDEO;
    case 'CHOICE':
    case 'AD_SELECTOR':
      return ANALYTICS_AD_FORMATS.AD_SELECTOR;
    case 'KERV_ENHANCED':
    case 'KERV':
    case 'ADVANCED':
      return ANALYTICS_AD_FORMATS.KERV_ENHANCED;
    case 'GATEWAY_GO':
      return ANALYTICS_AD_FORMATS.GATEWAY_GO;
    default:
      return adFormat.trim().toLowerCase().replace(/_/g, '-');
  }
};
